import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const SouthKoreaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_15280'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_15280)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.99935 10.2666C11.8403 10.2666 13.3327 8.80407 13.3327 6.99994C13.3327 5.19581 11.8403 3.73328 9.99935 3.73328C8.1584 3.73328 6.66602 5.19581 6.66602 6.99994C6.66602 8.80407 8.1584 10.2666 9.99935 10.2666Z'
					fill='#E01B41'
				/>
				<mask
					id='mask1_2332_15280'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='6'
					y='3'
					width='8'
					height='8'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M9.99935 10.2666C11.8403 10.2666 13.3327 8.80407 13.3327 6.99994C13.3327 5.19581 11.8403 3.73328 9.99935 3.73328C8.1584 3.73328 6.66602 5.19581 6.66602 6.99994C6.66602 8.80407 8.1584 10.2666 9.99935 10.2666Z'
						fill='white'
					/>
				</mask>
				<g mask='url(#mask1_2332_15280)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M6.66547 7.46663C7.61785 8.34163 9.04642 8.86663 9.9988 7.46663C10.9512 6.06663 12.8559 6.06663 13.3321 7.46663C13.8083 8.86663 13.3321 10.2666 13.3321 10.2666H6.66547C6.66547 10.2666 5.71309 6.59163 6.66547 7.46663Z'
						fill='#0E4B9C'
					/>
				</g>
				<path
					opacity='0.75'
					fillRule='evenodd'
					clipRule='evenodd'
					d='M14.9364 2.59011C14.7761 2.68076 14.722 2.88284 14.8155 3.04146L15.9056 4.89193C15.9991 5.05054 16.2047 5.10564 16.3649 5.01498L16.6095 4.87661C16.7697 4.78595 16.8239 4.58388 16.7304 4.42526L15.6402 2.57479C15.5468 2.41617 15.3412 2.36108 15.1809 2.45174L14.9364 2.59011ZM13.6992 3.29011C13.539 3.38076 13.4848 3.58284 13.5783 3.74146L14.6684 5.59193C14.7619 5.75054 14.9675 5.80564 15.1278 5.71498L15.3723 5.57661C15.5325 5.48595 15.5867 5.28388 15.4932 5.12526L14.4031 3.27479C14.3096 3.11617 14.104 3.06108 13.9437 3.15174L13.6992 3.29011ZM3.26845 9.57479C3.175 9.41617 3.22914 9.2141 3.38936 9.12344L3.63392 8.98507C3.79414 8.89441 3.99979 8.94951 4.09323 9.10812L5.18341 10.9586C5.27685 11.1172 5.22272 11.3193 5.06249 11.4099L4.81793 11.5483C4.65771 11.639 4.45207 11.5839 4.35862 11.4253L3.26845 9.57479ZM4.62654 8.42344C4.46632 8.5141 4.41218 8.71617 4.50562 8.87479L5.5958 10.7253C5.68924 10.8839 5.89489 10.939 6.05511 10.8483L6.29967 10.7099C6.45989 10.6193 6.51403 10.4172 6.42059 10.2586L5.33041 8.40812C5.23696 8.24951 5.03132 8.19441 4.8711 8.28507L4.62654 8.42344ZM14.6684 8.40812C14.7619 8.24951 14.9675 8.19441 15.1278 8.28507L15.3723 8.42344C15.5325 8.5141 15.5867 8.71617 15.4932 8.87479L14.4031 10.7253C14.3096 10.8839 14.104 10.939 13.9437 10.8483L13.6992 10.7099C13.539 10.6193 13.4848 10.4172 13.5783 10.2586L14.6684 8.40812ZM16.3649 8.98507C16.2047 8.89441 15.9991 8.94951 15.9056 9.10812L14.8154 10.9586C14.722 11.1172 14.7761 11.3193 14.9364 11.4099L15.1809 11.5483C15.3411 11.639 15.5468 11.5839 15.6402 11.4253L16.7304 9.57479C16.8239 9.41617 16.7697 9.2141 16.6095 9.12344L16.3649 8.98507ZM4.35862 2.57479C4.45207 2.41617 4.65771 2.36108 4.81793 2.45174L5.06249 2.59011C5.22272 2.68076 5.27685 2.88284 5.18341 3.04145L4.09323 4.89193C3.99979 5.05054 3.79414 5.10564 3.63392 5.01498L3.38936 4.87661C3.22914 4.78595 3.175 4.58388 3.26845 4.42526L4.35862 2.57479ZM6.05511 3.15174C5.89489 3.06108 5.68924 3.11617 5.5958 3.27479L4.50562 5.12526C4.41218 5.28388 4.46632 5.48595 4.62654 5.57661L4.8711 5.71498C5.03132 5.80564 5.23696 5.75054 5.33041 5.59193L6.42059 3.74145C6.51403 3.58284 6.45989 3.38076 6.29967 3.29011L6.05511 3.15174Z'
					fill='#262626'
				/>
			</g>
		</svg>
	);
};

export default SouthKoreaFlagIcon;
